import React, { useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const redirectState = useMemo(() => ({ from: location.pathname }), [location.pathname]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FFF2EC]">
        <div className="text-center">
          <Loader2 className="w-8 h-8 animate-spin mx-auto text-[#FF6B4A]" />
          <p className="mt-4 text-[#8C7A76]">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/" state={redirectState} replace />;
  }

  return children;
};

export default ProtectedRoute;
